/**
 * パスワードバリデーション共通ユーティリティ。
 * ルール: 半角英数字のみ、8〜20文字。
 * バックエンド（PasswordValidator.java）と同一ルール。
 */

const PASSWORD_PATTERN = /^[a-zA-Z0-9]{8,20}$/;

export const isPasswordValid = (password: string): boolean => {
  return PASSWORD_PATTERN.test(password);
};

export const PASSWORD_RULE_MESSAGE = 'パスワードは半角英数字8〜20文字で入力してください';
